import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { ResourceCustomLandingPage, ResourceNotFound } from '@/shared/constant/ResourceData';
import { UtmCampaign } from '@/shared/constant/utm';
import { ModelType } from '@tarslib/types/lib/common';
import React from 'react';

export function useGetResourceUtmCampaign() {
  const resourceDataType = useDocsDataModelStore((x) => x.resourceData.type);

  const result = React.useMemo(() => {
    if (resourceDataType === ResourceNotFound) {
      return UtmCampaign.ErrorPage;
    }

    return {
      [ModelType.Doc]: UtmCampaign.DocsMdPageFooter,
      [ModelType.ApiFolder]: UtmCampaign.DocsMdPageFooter,
      [ModelType.HttpApi]: UtmCampaign.DocsApiPageFooter,
      [ModelType.WebSocketApi]: UtmCampaign.DocsApiPageFooter,
      [ModelType.CUSTOM_ENDPOINT]: UtmCampaign.DocsApiPageFooter,
      [ModelType.SOCKET_IO_API]: UtmCampaign.DocsApiPageFooter,
      [ModelType.ApiSchema]: UtmCampaign.DocsApiPageFooter,
      [ResourceCustomLandingPage]: UtmCampaign.DocsMdPageFooter,
    }[resourceDataType];
  }, [resourceDataType]);

  return result;
}
